module.exports = __webpack_public_path__ + "img/arrow_left_circle.f62c08bd.svg";